import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { LabledMultilineTextField } from "../core/LabledMultilineTextField";

export const NewConnectionMultilineBuildingIntakeSpecification: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_BUILDING_INTAKE_SPECIFICATION
    >();
    return (
        <Fragment>
            <h3 className={classes.h3} style={{ marginTop: 28, marginBottom: 16 }}>
                Beschreibung
            </h3>

            <LabledMultilineTextField
                placeholder="Ihre Beschreibung"
                margin="none"
                inputProps={{
                    maxLength: 1000,
                }}
                value={values.newConnectionMultilineBuildingIntakeSpecification.value.text || ""}
                onChange={event => {
                    setValues(values => {
                        values.newConnectionMultilineBuildingIntakeSpecification.value.text =
                            event.target.value || null;
                    });
                }}
                error={values.newConnectionMultilineBuildingIntakeSpecification.error !== null}
            />

            <p className={classes.p} style={{ color: Colors.anthracite50 }}>
                Bitte beschreiben Sie kurz das von Ihnen verwendete Gebäudeeinführungssystem. Bitte
                beachten Sie hierbei die eingeblendete Hinweismeldung. Entsprechende
                Eignungsnachweise oder Zertifikate der Bauteile fügen Sie bitte dem Antrag unter
                &quot;Optionale Dokumente&quot; hinzu.
            </p>
        </Fragment>
    );
};
